import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'showOnlyHours' })
export class ShowOnlyHoursPipe implements PipeTransform {
  transform(value: string): string {
    const dateSplited = !value ? [] : value.split(' ');
    if (dateSplited.length === 3) {
      return dateSplited[1] + ' ' + dateSplited[2];
    }

    return value;
  }
}
